import { createSlice } from "@reduxjs/toolkit";
import { getMachines } from "./MachineActions";

const initialState = {
    loading: false,
    machines: [], // for machines array
    error: null,
    success: false, // for monitoring the registration process.
  }

const machinesSlice = createSlice({
    name: "machines",
    initialState,
    reducers: {},
    extraReducers:{
        [getMachines.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
            state.machines = payload.data
        },
        [getMachines.pending]: (state, {payload}) => {
            state.loading = true
        },
        [getMachines.rejected]: (state, {payload}) => {
            state.loading = false
            state.machines = payload
        }
    }
})

export default machinesSlice.reducer